import React from 'react';
import { Div, Icon, Text } from '@pinpoint/design-kit';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Button from 'src/components/button';
import CONSTANTS from 'src/store/constants';
import { appActions } from 'src/store/actions';
import { checkSufficientRole } from 'src/functions';

export function AirButtonGroup({ siteRole, selected, handleSelection, classifier, center = 0.0, factor = 0.0 }) {
  const dispatch = useDispatch();
  return (
    <Div d="flex" align="flex-start" p={{ t: classifier ? '0' : '1rem' }}>
      <Button
        disabled={selected === 0}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(0)}
      >
        <Icon viewBox="0 0 36 36" name="FairnessRace" color="white" m={{ r: '0.5rem' }} size="1rem" />
        RACE
      </Button>
      <Button
        disabled={selected === 1}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(1)}
      >
        <Icon viewBox="0 0 36 33" name="FairnessSex" color="white" m={{ r: '0.5rem' }} size="1rem" />
        SEX
      </Button>
      <Button
        disabled={selected === 2}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(2)}
      >
        <Icon viewBox="0 0 30 36" name="FairnessAge" color="white" m={{ r: '0.5rem' }} size="1rem" />
        AGE
      </Button>
      <Button
        disabled={selected === 3}
        buttonStyle="admin"
        textWeight="600"
        textSize="body"
        onClick={() => handleSelection(3)}
      >
        <Icon viewBox="0 0 33 36" name="FairnessAll" color="white" m={{ r: '0.5rem' }} size="1rem" />
        ALL
      </Button>
      <Div flexGrow="1" />
      {checkSufficientRole(siteRole, CONSTANTS.ROLE.CLIENT_SERVICES_ADMIN, true) && (
        <Div>
          <Text textAlign="right">
            Prediction Mean: {center}
            <Icon
              name="Copy"
              color="shadeCC"
              m={{ l: '0.5rem', t: '.5rem' }}
              size="1rem"
              viewBox="0 0 14 14"
              onClick={() => {
                navigator.clipboard.writeText(center.toFixed(10));
                dispatch(appActions.enqueueNotification('Copied prediction mean', { autoClose: true, timeout: 1500 }));
              }}
              data-tip="Copy"
              cursor="copy"
            />
          </Text>
          <Text textAlign="right">
            Compression Factor: {factor}
            <Icon
              name="Copy"
              color="shadeCC"
              m={{ l: '0.5rem', t: '.5rem' }}
              size="1rem"
              viewBox="0 0 14 14"
              onClick={() => {
                navigator.clipboard.writeText(factor.toFixed(10));
                dispatch(
                  appActions.enqueueNotification('Copied compression factor', { autoClose: true, timeout: 1500 })
                );
              }}
              data-tip="Copy"
              cursor="copy"
            />
          </Text>
        </Div>
      )}
    </Div>
  );
}

AirButtonGroup.defaultProps = {
  classifier: false,
};

AirButtonGroup.propTypes = {
  selected: PropTypes.number.isRequired,
  handleSelection: PropTypes.func.isRequired,
  classifier: PropTypes.bool,
  siteRole: PropTypes.string.isRequired,
  center: PropTypes.number.isRequired,
  factor: PropTypes.number.isRequired,
};

export function RemediateButton({ disabled, onClick }) {
  return (
    <Button disabled={disabled} buttonStyle="admin" textWeight="600" textSize="body" onClick={onClick}>
      <Icon name="Fairness" size="1rem" viewBox="0 0 37 36" color="white" m={{ r: '.5rem' }} />
      REMEDIATE
    </Button>
  );
}

RemediateButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
